import { useEffect } from "react";
import CategoryDetailTemplate from "../../../Templetes/Categories/Details/CategoryDetail.template";

const RobomissionKidsPage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Robo Mission Kids Challenge";
  }, []);
  return <CategoryDetailTemplate />;
};

export default RobomissionKidsPage;
